import React from "react";
import classNames from "classnames";

import { useMilestoneEdition } from "@planzone/view-models";
import { useMessage } from "@components/useMessage";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { events } from "@planzone/events";
import { Props } from "./types";
import { EditIcon } from "./editIcon";
import styles from "./styles.scss";

function NameEditionForm({ milestone, hovered }: Props) {
  const [name, setName] = React.useState(milestone.name);
  const { editMilestone, isRequestPending } = useMilestoneEdition(milestone);
  const inputRef = React.useRef<HTMLInputElement>(null);
  const nameRef = React.useRef<HTMLHeadingElement>(null);
  const [isHovered, setIsHovered] = React.useState(false);
  React.useEffect(() => {
    setName(milestone.name);
  }, [milestone.name]);

  useMessage(
    (message) =>
      message.type === events.editMilestoneFailed &&
      milestone.uuid === message.data.milestone.uuid &&
      setName(milestone.name),
  );
  const isTextTruncated = () => {
    if (nameRef.current) {
      return nameRef.current.offsetWidth < nameRef.current.scrollWidth;
    }
    return false;
  };

  return (
    <VisibilitySwitch
      renderChildren={(isVisible, show, hide) => (
        <div
          className={classNames(styles.nameEditionForm, {
            [styles.edition]: isVisible,
            [styles.pending]: isRequestPending,
            [styles.hovered]: hovered,
          })}
        >
          <form
            className={styles.form}
            onSubmit={(e) => {
              e.preventDefault();
              editMilestone({
                milestone,
                nextMilestone: { ...milestone, name },
              });
              hide();
            }}
          >
            <input
              ref={inputRef}
              className={styles.input}
              value={name}
              onBlur={() => {
                hide();
                setName(milestone.name);
              }}
              onChange={({ target }) => setName(target.value)}
            />
          </form>
          <div className={styles.name}>
            <h3
              ref={nameRef}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {milestone.name}
            </h3>
            {isTextTruncated() && isHovered && (
              <div className={styles.tooltip}>{milestone.name}</div>
            )}
            <div
              onClick={(e) => {
                e.stopPropagation();
                show();
                setTimeout(() => {
                  inputRef.current && inputRef.current.focus();
                });
              }}
            >
              <EditIcon className={styles.icon} style={{}} />
            </div>
          </div>
        </div>
      )}
    />
  );
}

export { NameEditionForm };
